/* eslint-disable no-console */
/* eslint-disable no-useless-concat */
/* eslint-disable no-underscore-dangle */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import { getPropertiesChangedOldFeature, getFeaturesTurf } from 'services/utils/layerUtils';
import { measureArea } from 'services/utils/measures';
import NoticeNotRun from 'services/utils/noticeNotRun';

import ButtonTooltip from '../../ButtonTooltip';

import { CustomModalSaveAsLayer } from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
import AlertConfirm from 'views/MapView/components/ToolBar/components/Analysis/IdentifyFeatureLocation/components/AlertConfirm';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

/**
 * Ferramenta Erase
 * Apagar informações de uma camada que soprepõem a área de apagar (interseção). 
 * Selecionando camadas criadas e/ou importadas, sendo uma camada de entrada 
 * (deve vim primeiro na lista de camadas) 
 * e outra camada de apagar (esta deverá ser do tipo polígono).
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Erase = ({ mapContext, isActive, setIsActive, ...props }) => {  
  const [arrSelectedLayers, setArrSelectedLayers] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);  
  const [runingErase, setRuningErase] = useState(false);
  const [collectionErase, setCollectionErase] = useState({});
  const [type, setType] = useState('');
  const { layers, map, addLayer, setLoadingInMap} = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
      ReactDOM.render(
        <AlertConfirm
          title='Apagar'          
          buttonStyle={{ width: '100px', marginTop: '30px' }}
          message='A geometria gerada pode sofrer deslocamento da posição de origem.'
          buttonText='Ok'
        />,
        document.getElementById('alert')
      ); 
    },
  });

  const { resetForm } = formik;

  /**
   * Salva a operação de erase realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionErase) {      
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            pane: 'mixedPane',
            ...layerStyle,
            renderer: customRender,
          });
        },
      };

      const geoJsonLayer = L.geoJSON(collectionErase, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );      
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);      
      let countIdFeature = 1;      
      layerToAdd.leafletLayer.eachLayer((feature) => {        
        let newFeatureProperties = {};
        newFeatureProperties.ID_GBA = countIdFeature;
        newFeatureProperties = {
          ...newFeatureProperties,
          ...feature.feature.properties,
        }
        // Verifica se é do tipo Point caso seja nao coloca a propriedade de 'area'
        if(collectionErase.features[0].geometry.type !== "Point" ) {          
          newFeatureProperties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
          newFeatureProperties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;
        }         
        feature.feature['properties'] = newFeatureProperties;
        
        countIdFeature++;
      });
      addLayer(layerToAdd);      
      setSaveModalOpen(false);
    }    
  }, [collectionErase, addLayer]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]);
  
  /**
   * Executa operação de erase sobre as feições
   * mantendo as respectivas colunas das feições envolvidas
   * renomeando-as com _X no final do label
   */
  const intersectFeatures = useCallback((arrFeaturesInitialLayer, arrFeaturesClipLayer ) => {
    let arrIntersectedFeatures = [];

    //Transforma array de feiçoes da camada de recorte em feature collection
    let collection = turf.featureCollection(arrFeaturesClipLayer)
    //Dissolve
    let dissolve = turf.dissolve(collection);
    //Combina as feiçoes
    let combine = turf.combine(dissolve)    
    //Seta as propriedades da feição
    combine.features[0].properties = collection.features[0].properties
    let eraseLayer = []
    eraseLayer.push(...combine.features)

    // Point
    if(["Point", "MultiPoint"].includes(arrFeaturesInitialLayer[0].geometry.type)){ 
      arrFeaturesInitialLayer.forEach((point) => {        
        let p = turf.pointsWithinPolygon(point, eraseLayer[0])
        if(!p.features.length > 0) {
          point['properties'] = {
            ...getPropertiesChangedOldFeature(point.properties)
          }
          arrIntersectedFeatures.push(point)
        }
      })    

      return arrIntersectedFeatures;
    }

    // Polygon
    if(["Polygon", "MultiPolygoon"].includes(arrFeaturesInitialLayer[0].geometry.type)){ 
      arrFeaturesInitialLayer.forEach((featurePolygon, index) => {
        //Seta as diferenças
        arrIntersectedFeatures.push(turf.difference(featurePolygon, eraseLayer[0]));
        //Seta as propriedades
        if(arrIntersectedFeatures[index] !== null){
          arrIntersectedFeatures[index].properties = { ...getPropertiesChangedOldFeature(featurePolygon.properties)}
        }
      });

      return arrIntersectedFeatures;
    }
  }, []);

  /**
   * Inicia procedimento para execução da interseção
   */
  const runErase = useCallback(() => {         
    if (!runingErase) {
      setRuningErase(true);
      setLoadingInMap(true);      
      // Foi necessário executar a operação de de intersect dentro de um setTimeout, 
      // pois o mesmo trava a aplicação, impedindo a visualização do "loading".
      setTimeout(function () {        

        let arrIntersectedFeatures;
        try {
          arrIntersectedFeatures = intersectFeatures(getFeaturesTurf(arrSelectedLayers[0]), getFeaturesTurf(arrSelectedLayers[1]));
          arrIntersectedFeatures = arrIntersectedFeatures.filter((f) => f); 

          if (arrIntersectedFeatures?.length > 0) {
            let type = arrSelectedLayers[0].dataType
            setCollectionErase(turf.featureCollection(arrIntersectedFeatures));
            setSaveModalOpen(true);
            setType(type)
          } else {             
            throw new Error();
          }   

        } catch {          
          NoticeNotRun({
            title: 'Apagar',
            message: 'Não foi possível realizar operação.',
            buttonText: 'OK',
          });
        } 

        setRuningErase(false);   
        setLoadingInMap(false);
      }, 500);
    }      
  }, [runingErase, arrSelectedLayers, intersectFeatures, setLoadingInMap]);  
  
  /** EFFECTS */

  /**
   * Habilita ferramenta de acordo com a camada selecionada, visibilidade e tipo
   */
  useEffect(() => {
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);  
    if ((selectedLayers.length === 2
      && ['importada', 'criada'].includes(selectedLayers[0].type)
      && ['importada', 'criada'].includes(selectedLayers[1].type)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[1].dataType))
      ) {
        // Desabilita a ferramenta caso a camada de entrada seja do tipo linha
        if(["LineString", "MultiLineString"].includes(selectedLayers[0].dataType)){
          return setArrSelectedLayers([]);    
        }
        setArrSelectedLayers([selectedLayers[0], selectedLayers[1]]);
    } else {
      setArrSelectedLayers([]);
    }
  }, [layers]);

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {      
      handleCloseSaveModal(); 
      setType('')  
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */
  useEffect(() => {
    if (isActive && !runingErase) {
      map.on('run-erase', runErase);
      map.fire('run-erase'); 
      setIsActive(false);      
      map.off('run-erase');
    }
  }, [isActive, runingErase, map, runErase, setIsActive]);
  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Erase.properties.alias}
        description={Erase.properties.description}
        onClick={() => {          
          setIsActive();          
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={arrSelectedLayers.length === 0}
      >        
        <Icon i="map-toolbar-erase"></Icon>
      </ButtonTooltip>     

          <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={ <SliderColorPicker
          geometryType={type || "Polygon"}
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      /> 
  
    </Wrap>
  );
};

Erase.properties = {
  id: 'CPN-TB-A-ERASE',
  alias: 'Apagar',
  description: 'Apagar informações de uma camada que soprepõem a área de apagar (interseção). Selecionando camadas criadas e/ou importadas, sendo uma camada de entrada do tipo polígono ou ponto (deve vim primeiro na lista de camadas) e outra camada de apagar (esta deverá ser do tipo polígono).',
};

export default Erase;
